import React, { useContext, useState, useEffect } from 'react';
import AppContext from '../../../App/AppContext';
import { Grid, Button, InputLabel, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormHelperText } from '@material-ui/core';
import { TextBox, DateTimePicker, SecondaryButton, SingelSelect } from '../../FormInput';
import { addVehicle, getVehicleScreenDropdowns } from '../../Service/create-job-service';
import { getCustomerScreenDropdown } from '../../Service/admin-service';

const VehicleModal = ({ open, onClose, defaultReg }) => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        RegistrationNumber: defaultReg || '',
        VehicleNumber: '',
        FranModelVariant: '',
        Franchise: '',
        ModelCode: '',
        ModelVariant: '',
        BodyStyle: '',
        CC: '',
        FuelTypeId: '',
        ColourWheelbase: '',
        DateRegistered: '',
        EngineNumber: '',
        Description: '',
        ChassisNumber: '',
        VehicleTypeID: '',
        CustomerId: '',
        AccountCode: ''
    });

    const [dropdowns, setDropdowns] = useState({});
    const [errors, setErrors] = useState({});
    const [isBtnLoader, setIsBtnLoader] = useState(false);
    const [customerData, setcustomerData] = useState({
        customers: []
    });

    const [tempOptions, setTempOptions] = useState({
        franchiseValue: null,
        vehicleTypeIDValue: null,
        customerIDValue: null
    });

    const singleSelectChange = (nm) => (ev, val) => {
        setTempOptions((st) => ({ ...st, [nm]: val }));
        
        let errorName = nm;
        if (nm === 'franchiseValue') errorName = 'Franchise';
        if (nm === 'vehicleTypeIDValue') errorName = 'VehicleTypeID';
        if (nm === 'customerIDValue') errorName = 'CustomerId';
        
        if (errors[errorName]) {
            setErrors((errs) => ({ ...errs, [errorName]: null }));
        }
    };

    useEffect(() => {
        const fetchDropdowns = async () => {
            try {
                const [resCust, resVeh] = await Promise.all([getCustomerScreenDropdown(), getVehicleScreenDropdowns()]);

                if (resCust && resCust.success) {
                    const customers = resCust?.data?.customers || [];
                    setcustomerData((st) => ({ ...st, customers }));
                }

                if (resVeh && resVeh.success && resVeh.data) {
                    setDropdowns(resVeh.data);
                }
            } catch (err) {
                console.error(err);
            }
        };
        fetchDropdowns();
    }, []);

    const fieldChange = (event) => {
        const { name, value } = event.target;
        setState((st) => ({
            ...st,
            [name]: value
        }));
        if (errors[name]) {
            setErrors((errs) => ({ ...errs, [name]: null }));
        }
    };

    const handleSave = async () => {
        let newErrors = {};
        const requiredFields = [
            'RegistrationNumber',
            'FranModelVariant',
            'ModelCode',
            'ModelVariant',
            'BodyStyle',
            'FuelTypeId',
            'ColourWheelbase',
            'EngineNumber',
            'Description',
            'ChassisNumber',
            'AccountCode'
        ];

        requiredFields.forEach((field) => {
            if (!state[field] || String(state[field]).trim() === '') {
                newErrors[field] = 'Required';
            }
        });

        if (!tempOptions.franchiseValue || !tempOptions.franchiseValue.id) {
            newErrors.Franchise = 'Required';
        }
        if (!tempOptions.vehicleTypeIDValue || !tempOptions.vehicleTypeIDValue.id) {
            newErrors.VehicleTypeID = 'Required';
        }
        if (!tempOptions.customerIDValue || !tempOptions.customerIDValue.id) {
            newErrors.CustomerId = 'Required';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            showToast('Please fill all mandatory fields', 'error');
            return;
        }

        const payload = {
            ...state,
            VehicleNumber: state.VehicleNumber ? parseInt(state.VehicleNumber) : null,
            CC: state.CC ? parseInt(state.CC) : null,
            FuelTypeId: state.FuelTypeId ? parseInt(state.FuelTypeId) : null,
            VehicleTypeID: tempOptions.vehicleTypeIDValue && tempOptions.vehicleTypeIDValue.id ? parseInt(tempOptions.vehicleTypeIDValue.id) : null,
            CustomerId: tempOptions.customerIDValue && tempOptions.customerIDValue.id ? parseInt(tempOptions.customerIDValue.id) : null,
            Franchise: tempOptions.franchiseValue ? tempOptions.franchiseValue.id : '',
            DateRegistered: state.DateRegistered || null
        };

        setIsBtnLoader(true);
        try {
            let res = await addVehicle(payload);
            if (res && res.success) {
                showToast(res.data?.message || 'Vehicle added successfully!');
                onClose(true, payload);
            } else {
                showToast('Error adding vehicle', 'error');
            }
        } finally {
            setIsBtnLoader(false);
        }
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth="md" fullWidth>
            <DialogTitle>Add New Vehicle</DialogTitle>
            <DialogContent dividers style={{ overflowY: 'auto' }}>
                <Grid container spacing={2}>
                    {/* -- ROW 1: Identifiers -- */}
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error>
                            Registration No
                        </InputLabel>
                        <TextBox name="RegistrationNumber" value={state.RegistrationNumber} onChange={fieldChange} />
                        {errors.RegistrationNumber && <FormHelperText error>{errors.RegistrationNumber}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error>
                            Chassis Number
                        </InputLabel>
                        <TextBox name="ChassisNumber" value={state.ChassisNumber} onChange={fieldChange} />
                        {errors.ChassisNumber && <FormHelperText error>{errors.ChassisNumber}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error>
                            Engine Number
                        </InputLabel>
                        <TextBox name="EngineNumber" value={state.EngineNumber} onChange={fieldChange} />
                        {errors.EngineNumber && <FormHelperText error>{errors.EngineNumber}</FormHelperText>}
                    </Grid>

                    {/* -- ROW 2: Make & Franchise -- */}
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error>
                            Make / Model Code
                        </InputLabel>
                        <TextBox name="ModelCode" value={state.ModelCode} onChange={fieldChange} />
                        {errors.ModelCode && <FormHelperText error>{errors.ModelCode}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error>
                            Model Variant
                        </InputLabel>
                        <TextBox name="ModelVariant" value={state.ModelVariant} onChange={fieldChange} />
                        {errors.ModelVariant && <FormHelperText error>{errors.ModelVariant}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error={!!errors.Franchise}>
                            Franchise
                        </InputLabel>
                        <SingelSelect
                            options={dropdowns?.franchiseRecords || []}
                            value={tempOptions.franchiseValue}
                            onChange={singleSelectChange('franchiseValue')}
                        />
                        {errors.Franchise && <FormHelperText error>{errors.Franchise}</FormHelperText>}
                    </Grid>

                    {/* -- ROW 3: More Model Details & Body -- */}
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error>
                            Fran Model Variant
                        </InputLabel>
                        <TextBox name="FranModelVariant" value={state.FranModelVariant} onChange={fieldChange} />
                        {errors.FranModelVariant && <FormHelperText error>{errors.FranModelVariant}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error>
                            Body Style
                        </InputLabel>
                        <TextBox name="BodyStyle" value={state.BodyStyle} onChange={fieldChange} />
                        {errors.BodyStyle && <FormHelperText error>{errors.BodyStyle}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error={!!errors.VehicleTypeID}>
                            Vehicle Type
                        </InputLabel>
                        <SingelSelect
                            options={(dropdowns?.vehicleType || []).map(v => ({ id: v.id, name: v.name || v.description }))}
                            value={tempOptions.vehicleTypeIDValue}
                            onChange={singleSelectChange('vehicleTypeIDValue')}
                        />
                        {errors.VehicleTypeID && <FormHelperText error>{errors.VehicleTypeID}</FormHelperText>}
                    </Grid>

                    {/* -- ROW 4: Specs -- */}
                    <Grid item xs={12} sm={6} md={3}>
                        <InputLabel shrink required error>
                            Fuel Type
                        </InputLabel>
                        <TextField
                            select
                            SelectProps={{ native: true }}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            name="FuelTypeId"
                            value={state.FuelTypeId}
                            onChange={fieldChange}
                        >
                            <option value=""></option>
                            {dropdowns?.fuelType?.map((f) => (
                                <option key={f.id} value={f.id}>
                                    {f.name || f.description}
                                </option>
                            ))}
                        </TextField>
                        {errors.FuelTypeId && <FormHelperText error>{errors.FuelTypeId}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <InputLabel shrink>CC</InputLabel>
                        <TextBox name="CC" value={state.CC} onChange={fieldChange} type="number" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <InputLabel shrink required error>
                            Colour Wheelbase
                        </InputLabel>
                        <TextBox name="ColourWheelbase" value={state.ColourWheelbase} onChange={fieldChange} />
                        {errors.ColourWheelbase && <FormHelperText error>{errors.ColourWheelbase}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <InputLabel shrink>Vehicle Number</InputLabel>
                        <TextBox name="VehicleNumber" value={state.VehicleNumber} onChange={fieldChange} type="number" />
                    </Grid>

                    {/* -- ROW 5: Admin -- */}
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error={!!errors.CustomerId}>
                            Customer
                        </InputLabel>
                        <SingelSelect
                            options={(customerData?.customers || []).map(c => ({ id: c.id || c.customerId, name: c.name || c.customerName }))}
                            value={tempOptions.customerIDValue}
                            onChange={singleSelectChange('customerIDValue')}
                        />
                        {errors.CustomerId && <FormHelperText error>{errors.CustomerId}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink required error>
                            Account Code
                        </InputLabel>
                        <TextBox name="AccountCode" value={state.AccountCode} onChange={fieldChange} />
                        {errors.AccountCode && <FormHelperText error>{errors.AccountCode}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputLabel shrink style={{ marginBottom: 8 }}>
                            Date Registered
                        </InputLabel>
                        <DateTimePicker name="DateRegistered" value={state.DateRegistered} onChange={fieldChange} />
                    </Grid>

                    {/* -- ROW 6: Notes -- */}
                    <Grid item xs={12}>
                        <InputLabel shrink required error>
                            Description
                        </InputLabel>
                        <TextBox name="Description" value={state.Description} onChange={fieldChange} multiline minRows={2} />
                        {errors.Description && <FormHelperText error>{errors.Description}</FormHelperText>}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)} color="default">
                    CANCEL
                </Button>
                <SecondaryButton onClick={handleSave} isBtnLoader={isBtnLoader}>
                    SAVE VEHICLE
                </SecondaryButton>
            </DialogActions>
        </Dialog>
    );
};

export default VehicleModal;
